export default {"src":"/_next/static/media/youtube_dark.b48a20e3.svg","height":909,"width":909,"blurWidth":0,"blurHeight":0};